module.exports = __webpack_public_path__ + "static/neihu1-2cec206805bf8eb9cd65ef85678bcd79.jpg";